import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { http } from "../../services/http";
import { useAlert } from "react-alert";
import { PagingState, EditingState, CustomPaging, FilteringState, DataTypeProvider } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow, PagingPanel, TableEditRow, TableEditColumn, TableColumnVisibility, TableFixedColumns } from "@devexpress/dx-react-grid-material-ui";
import { QueryString, TIMER_FILTER } from "../utils/react_grid_utils";
import authenticatedUserContext from "../security/AuthenticatedUserContext";
import SettingsIcon from '@mui/icons-material/Settings';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

import { Alert, InputAdornment, Grid as MIUGrid, Snackbar, Tooltip} from '@mui/material'

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CookieService from "../../services/CookieService";
import Divider from '@mui/material/Divider';
import TextField from "@material-ui/core/TextField";
import { Box, Typography } from '@mui/material';
import { Add, DateRange, Delete, List } from "@material-ui/icons";
import { MenuItem } from "@material-ui/core";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
import { ContentCopy } from "@mui/icons-material";
import Header from "../Header";


let user = CookieService.get("user");
const emailAdmin = process.env.REACT_APP_EMAIL_ADMIN;
const getRowId = (row) => row.id;
const api_resource = "/parameters";
const bots_api_resource = "/bots"

const DateFormatter = ({ value }) => {
  if (!value) return "";
  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const DateEditor = ({ value, onValueChange }) => {
  const handleChange = (e) => {
    onValueChange(e.target.value);
  };
  return (
    <input
      type="date"
      value={value ? new Date(value).toISOString().split("T")[0] : ""}
      onChange={handleChange}
    />
  );
};

const DateTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={DateFormatter}
    editorComponent={DateEditor}
    {...props}
  />
);

const BooleanFormatter = ({ value }) => (
  value ? 
    <Tooltip title="Ativo">
      <CheckCircleIcon style={{ color: green[500] }} /> 
    </Tooltip>
    : 
    <Tooltip title="Inativo">
      <CancelIcon style={{ color: red[500] }} />
    </Tooltip>
    
);

// Tipo customizado que usa apenas o BooleanFormatter para visualização
const BooleanTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={BooleanFormatter}
    {...props}
  />
);

const PasswordFormatter = ({ value }) => {
  if (value === null || value === undefined || value === "") return "";
  return "******";
};

const PasswordEditor = ({ value, onValueChange }) => (
  <input
    type="password"
    value={value || ""}
    onChange={(e) => onValueChange(e.target.value)}
  />
);

const PasswordTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={PasswordFormatter}
    editorComponent={PasswordEditor}
    {...props}
  />
);

const TypeFormatter = ({ value }) => {
  return value === 'Parâmetro' ? 
  <Tooltip title="Parâmetro">
    <SettingsIcon />
  </Tooltip>
   : 
   <Tooltip title="Credencial">
    <VpnKeyIcon />
   </Tooltip> ;
};

const TypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={TypeFormatter}
    {...props}
  />
);


const ParametroTable = () => {
  const alert = useAlert();
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize] = useState(15);
  const [totalItens, setTotalItens] = useState(0);
  const [rows, setRows] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [editingRowIds, setEditingRowIds] = useState([]);
  const [defaultHiddenColumnNames, setDefaultHiddenColumnNames] = useState(["id"]);
  const [addedRows, setAddedRows] = useState([]);
  const [rowChanges, setRowChanges] = useState({});
  const [filters, setFilters] = useState([]);
  const [tableColumnExtensions] = useState([
    { columnName: "enable", width: '10%' },
    //{ columnName: "id", width: 60 },
    { columnName: "name", width:'20%' },
    { columnName: "description", width: '25%' },
    { columnName: "key", width: '15%' },
    { columnName: "value", width: '20%' },
    { columnName: "type", width: '10%' },
    //{ columnName: "password", width: 200 },
    //{ columnName: "bot_id", width: 200 },
  ]);
  const [bots, setBots] = useState([]);
  const [rowTypes, setRowTypes] = useState({});
  const [userAccess, setUserAccess] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  //
  const [id, setId] = useState(0)
  const [botId, setBotId] = useState(0)
  const [name, setName] = useState('')
  const [key, setKey] = useState('')
  const [description, setDescription] = useState('')
  const [type, setType] = useState('parameter')
  const [format, setFormat] = useState('string');
  const [options, setOptions] = useState(';');
  const [status, setStatus] = useState(false)
  const [rawValue, setRawValue] = useState('')
  const [password, setPassword] = useState('')
  const [viewValue, setViewValue] = useState('')
  const [createdAt, setCreatedAt] = useState('')
  const [updatedAt, setUpdatedAt] = useState('')
  const [originalValue, setOriginalValue] = useState('')
  //const [jsontext, setJsonText] = useState('')
  const [jsonData, setjsonData] = useState({});

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleStartValue = (raw_value, format) => {
    if (format === 'list'){
      const view_value = raw_value.split(options).join('\n')
      setViewValue(view_value)
    }else if (format === 'json'){
      let json_parsed = {}
      try {
        json_parsed = JSON.parse(raw_value)
      } catch (error) {
        console.log('Valor inválido para JSON:', error)
      }
      setjsonData(json_parsed)
    }
    else{
      setViewValue(raw_value)
    }
  }

  const handleUpdateValue = (updated_value) => {
    if (format === 'list'){
      if (options != ''){
        const view_value = updated_value.split(options).join('\n')//updated_value.replace(new RegExp(separator, 'g'), ''); // Remover o separador para evitar conflitos na lista
        // Substituir quebras de linha reais pelo separador
        const raw_value = view_value.replace(/\n/g, options);
        setViewValue(view_value)
        setRawValue(raw_value)
      }else{
        setViewValue(updated_value)
        setRawValue(updated_value)
      }
    }else if(format === 'json'){
      setRawValue(getJSONOutput())
    }
    else{
      setViewValue(updated_value)
      setRawValue(updated_value)
    }
  }

  const handleUpdateFormat = (value) => {
    setFormat(value)
    if (value === 'json'){
      let json_parsed = {}
      try {
        json_parsed = JSON.parse(rawValue)
      } catch (error) {
        console.log('Valor inválido para JSON:', error)
      }
      setjsonData(json_parsed)
    }else{
      setViewValue(rawValue)
    }
 
  };

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toLocaleDateString("pt-BR"); // Formato DD/MM/YYYY
    const formattedTime = date.toLocaleTimeString("pt-BR", { hour: '2-digit', minute: '2-digit' }); // Formato HH:MM
    return `${formattedDate} ${formattedTime}`;
  };

  const formatDateForApi = (date) => {
    if (!date) return "";
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const typeMapping = {
    parameter: "Parâmetro",
    credential: "Credencial",
  };

  const determineRowType = (row) => {
    return row.password ? "credential" : "parameter";
  };

  const commitChanges = () => {
    //return
    if (id) {
      const updatedValues = {
        id: id,
        bot_id: botId,
        name: name,
        key: key,
        value: rawValue,
        password: password,
        description: description,
        enable: status,
        type: type,
        user: user,
        format: format,
        options: options,
        //expirated_at: formatDateForApi(changed[row.id].expirated_at),
      };
      Update(api_resource + '/' + id, updatedValues)
        .then(() => {
          //setRows((prevRows) => prevRows.map(r => (r.id === id ? updatedValues : r)));
          //updateRowType(id, updatedValues);
          getParameters(selectedOption.id)
          handleClose()
          //alert.success('Parâmetro atualizado com sucesso!')
        })
        .catch((error) => {
          console.error("Erro ao atualizar:", error);
        });
    }
  }

  function getAllBots() {
    return http.get(bots_api_resource);
  }

  const Update = (api_resource, data) => {
    return new Promise((resolve, reject) => {
      http.put(api_resource, data).then(
        (response) => {
          alert.success("Parâmetro atualizado com sucesso!");
          resolve(response);
        },
        (error) => {
          alert.show("Erro ao atualizar o parâmetro", { type: "error" });
          reject(error);
        }
      );
    });
  };

  function getParameters(botId) {
    const queryString = QueryString(pageIndex, pageSize, filters);
    http.get(`${api_resource}/${botId}${queryString}`).then(
      (response) => {
        //const filteredRows = response.data.filter(row => row.enable);
        setRows(response.data.data);
        setTotalItens(parseInt(response.data.total, 10));

        // Atualiza os tipos das linhas recuperadas
        updateRowTypes(response.data.data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  //Modal
  const [selectedRow, setSelectedRow] = useState(null); 
  const [open, setOpen] = useState(false); 

  const handleClickOpen = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //
  const handleSelectionChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    if(selectedId){
      let selectedRow
      if(selectedId === -1){
        selectedRow = {
          id: -1,
          name: 'Global'
        }
      }else{
        selectedRow = bots.find((bot) => bot.id === selectedId);
      }
      setSelectedOption(selectedRow);
    }else{
      setSelectedOption(undefined)
    }
    
  };

  const handleUpdatePassword = (password) => {
    setPassword(password)
  }

  const updateRowTypes = (updatedRows) => {
    const updatedTypes = {};
    updatedRows.forEach((row) => {
      updatedTypes[row.id] = determineRowType(row);
    });
    setRowTypes(updatedTypes);
  };

  const updateRowType = (rowId, updatedRow) => {
    const updatedType = determineRowType(updatedRow);
    setRowTypes((prevTypes) => ({
      ...prevTypes,
      [rowId]: updatedType,
    }));
  };

  const [timer, setTimer] = useState(null);

  function handleFilters(filters) {
    clearTimeout(timer);
    setFilters(filters);

    setTimer(
      setTimeout(() => {
        if (selectedOption) {
          getParameters(selectedOption.id);
        }
      }, TIMER_FILTER)
    );
  }

  const columns = [
    { name: "type", title: "Tipo", getCellValue: (row) => row.password ? 'Credencial' : 'Parâmetro' },
    { name: "enable", title: "Status" },
    { name: "name", title: "Nome" },
    { name: "description", title: "Descrição" },
    //{ name: "id", title: "ID" },
    { name: "key", title: "Chave" },
    { name: "value", title: "Valor" },
    //{ name: "password", title: "Senha" },
    //{ name: "format", title: "Formato"},
    //{ name: "expirated_at", title: "Data de Expiração" },
    
  ];

  const TableRowComponent = ({ row, ...restProps }) => (
    <TableRow
       {...restProps}
       style={{ cursor: "pointer" }} // Cursor to indicate clickable row
       onClick={() => handleClickOpen(row)} // Event handler to open modal
    />
 );

  const userCanEdit = (botName) => {
    if (selectedOption?.name === 'Global' && authenticatedUserContext.allow_edit('Parâmetros'))
      return true
    const access = userAccess.find(access => access.name === botName && access.checked  && access.allow_edit);
    return access ? access.allow_edit : false;
  };

  const capitalizeFirstLetter = (str) => {
    return str
      .replace(/_/g, ' ') // Substitui "_" por espaço
      .split(' ')          // Divide a string em palavras
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitaliza cada palavra
      .join(' ');          // Junta as palavras de volta com espaços
  };

  const updateField = (group, index, key, value, type='') => {
    const updatedJsonData = { ...jsonData };
    const jsonGroup = updatedJsonData[group]
    if (Array.isArray(jsonGroup)){
      updatedJsonData[group][index][key] = value;
    }else{
      if (type === 'key'){
        // ADD BOTAO PARA DEL E ADD
        const old_value = updatedJsonData[group][key]
        delete updatedJsonData[group][key]; // Remove a chave antiga
        updatedJsonData[group][value] = old_value; // Atualiza o objeto na posição 'index'
      }
      else{
        updatedJsonData[group][key] = value;
      }
        
    }
    setjsonData(updatedJsonData); // Atualiza o estado com os novos valores
    setRawValue(getJSONOutput())
  };
  
  const handleCopy = (content) => {
    navigator.clipboard.writeText(content).then(() => {
      setSnackbarOpen(true)
    }).catch(() => {
      alert.error('Falha ao copiar o texto.');
    });
  };

  const renderJsonFields = (jsonGroup, group, fields) => {
    // Verifica se jsonGroup é um array
    if (Array.isArray(jsonGroup)) {
      return jsonGroup.map((item, index) => (
        <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          {fields.map((field) => (
            <TextField
              key={field}
              variant="outlined"
              disabled={!userCanEdit(selectedOption?.name)}
              fullWidth
              label={capitalizeFirstLetter(field)}
              value={item[field] || ''} // Acesse o valor do campo se existir
              name={field}
              onChange={(e) => updateField(group, index, field, e.target.value)} // Atualiza o campo específico
            />
          ))}
          <Tooltip title="Remover Item">
            <Button 
              disabled={!userCanEdit(selectedOption?.name)}
              variant="text" 
              onClick={() => removeItem(group, index)}>
              <Delete />
            </Button>
          </Tooltip>
        </div>
      ));
    } else {
      return <div>Não há dados disponíveis ou o formato dos dados é inválido.</div>;
    }
  };

  const renderJsonKeyValue = (key, jsonValues) => {
    // Verifica se jsonValues é um objeto válido
    try {
      return Object.entries(jsonValues).map(([keyy, value], index) => (
        <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
          {/* Campo para chave */}
          <TextField
            variant="outlined"
            disabled={!userCanEdit(selectedOption?.name)}
            fullWidth
            label="Chave"
            value={keyy || ''} // Usa keyy como valor
            name={`key_${keyy}`} // Nome do campo como 'key_keyy'
            onChange={(e) => updateField(key, index, keyy, e.target.value, 'key')} // Update o campo da chave
          />
          
          {/* Campo para valor */}
          <TextField
            variant="outlined"
            disabled={!userCanEdit(selectedOption?.name)}
            fullWidth
            label="Valor"
            value={value || ''} // Usa value como valor
            name={`value_${keyy}`} // Nome do campo como 'value_keyy'
            onChange={(e) => updateField(key, index, keyy, e.target.value, 'value')} // Update o campo do valor
          />
        </div>
      ));
    } catch (error) {
      return <div>Não há dados disponíveis ou o formato dos dados é inválido.</div>;
    }
  };
   
  const renderJsonData = () => {
    
    return Object.keys(jsonData).map((key) => {
      const jsonGroup = jsonData[key];  // A chave aqui é o nome do grupo, como 'group1', 'group2'
      
      // Verifica se jsonGroup é um array
      if (Array.isArray(jsonGroup)) {
        return (
          <div key={key} style={{ marginBottom: '20px' }}>
            <div className="row">
              <h3
                style={{
                  color: '#3f51b5',
                  marginRight: '8px',
                  marginBottom: '8px',
                  marginLeft: '14px',
                  fontWeight: 800,
                }}
              >
                <List style={{ marginBottom: 4 }} /> {key}  {/* Aqui, 'key' é o nome do grupo */}
              </h3>
              <Tooltip title="Adicionar Item">
                <Button 
                  disabled={!userCanEdit(selectedOption?.name)}
                  style={{ padding: 0 }} 
                  onClick={() => addItem(key)}>
                  <Add style={{ marginBottom: 8 }} />
                </Button>
              </Tooltip>
            </div>
            {renderJsonFields(jsonGroup, key, options.split(';'))}  {/* Passa o array para renderizar */}           
          </div>
        );
      } else if (typeof jsonGroup === 'object' && jsonGroup !== null) {
        return (
          <div key={key} style={{ marginBottom: '20px' }}>
            <div className="row">
              <h3
                style={{
                  color: '#3f51b5',
                  marginRight: '8px',
                  marginBottom: '8px',
                  marginLeft: '14px',
                  fontWeight: 800,
                }}
              >
                <List style={{ marginBottom: 4 }} /> {key}  {/* Aqui, 'key' é o nome do grupo */}
              </h3>
              <Tooltip title="Adicionar Item">
                <Button 
                  disabled={!userCanEdit(selectedOption?.name)}
                  style={{ padding: 0 }} 
                  onClick={() => addItem(key)}>
                  <Add style={{ marginBottom: 8 }} />
                </Button>
              </Tooltip>
            </div>
            {renderJsonKeyValue(key, jsonGroup)}  {/* Passa o array para renderizar */}           
          </div>
        )  
      }
      else {
        console.log('jsonGroup', jsonGroup)
        return <div key={key}>Dados inválidos para o grupo {key}</div>;
      }
    });
  };
  
  
  

  // Função para remover um contato de um grupo
  const removeItem = (group, index) => {
    const newData = { ...jsonData};
    newData[group].splice(index, 1);
    if (newData[group].length === 0) {
      delete newData[group];
    }
    setjsonData(newData);
    handleUpdateValue('')
  };

  // Função para adicionar um novo contato a um grupo
  const addItem = (group) => {
    const newData = { ...jsonData };
    newData[group] = newData[group] || [];
    newData[group].push(
      options.split(';').reduce((acc, option) => ({ ...acc, [option]: '' }), {})
    );
    //newData[group].push({ name: '', mail: '', telephone: '' });
    setjsonData(newData);
    handleUpdateValue('')
  };

  // Função para adicionar um novo grupo
  const addGroup = () => {
    const groupName = prompt("Digite o nome do novo grupo:");
    if (groupName) {
      if (!jsonData || Object.keys(jsonData).length === 0){
        setjsonData({ [groupName]: [] }); // Cria um novo grupo vazio
        return
      }
      const firstKey = Object.keys(jsonData)[0];
      const jsonGroup = jsonData[firstKey];  // pegar primeiro index para validar
      // Verifica se jsonGroup é um array
      if (Array.isArray(jsonGroup)) {
        setjsonData({ ...jsonData, [groupName]: [] });
      }else{
        const updatedJsonData = { ...jsonData };
        // Verifica se o grupo existe no JSON
        if (!updatedJsonData[groupName]) {
          // Adiciona o novo campo ao grupo existente
          updatedJsonData[groupName] = '';
        } else {
          // Se o grupo não existir, cria o grupo com o novo campo
          updatedJsonData[groupName] = { [key]: '' };
        }
      }
    }
    handleUpdateValue('')
  };

  const getJSONOutput = () => JSON.stringify(jsonData);

  const userCanView = () => {
    if (user?.email === emailAdmin)
      return true
    if (selectedOption?.name === 'Global' && user?.user_access?.some((e) => e.name === "Parâmetros"))
      return true
    if (user?.user_access?.some((e) => e.name === selectedOption?.name)) //can view
      return true
    
    return false
  }

  const disableFields = () => {
    return !authenticatedUserContext.allow_edit('Parâmetros')
  }

  //
  // useEffect(() => {
  //   // Supondo que jsonData seja carregado ou modificado em algum ponto
  //   console.log('useEffect jsonData', jsonData)
  //   const validatedJsonData = Object.keys(jsonData).reduce((acc, key) => {
  //     if (Array.isArray(jsonData[key])) {
  //       acc[key] = jsonData[key];
  //     } else {
  //       acc[key] = []; // ou algum valor padrão, caso necessário
  //     }
  //     return acc;
  //   }, {});
  
  //   setjsonData(validatedJsonData);
  // }, [jsonData]);
  

  useEffect(() => {
    //Set User
    if (user && user.user_access) {
      setUserAccess(user.user_access);
    }
  }, []); //[user]);

  useEffect(() => {
    getAllBots()
      .then((response) => {
        setBots(response.data);
      })
      .catch((error) => {
        console.error("Error fetching bots:", error);
      });
  }, []);

  useEffect(() => {
    handleUpdateValue(rawValue)
  }, [options])

  useEffect(() => {
    if (selectedOption) {
      getParameters(selectedOption.id);
    } else {
      setRows([]);
      setTotalItens(0);
    }
  }, [selectedOption, pageIndex, pageSize, filters]);

  useEffect(() => {
    if (selectedRow){
      setId(selectedRow.id ?? 0)
      setBotId(selectedRow.bot_id ?? 0)
      setName(selectedRow.name ?? '')
      setType(selectedRow.type ?? '')
      setKey(selectedRow.key ?? '')
      setDescription(selectedRow.description ?? '')
      setCreatedAt(selectedRow.created_at ?? '')
      setUpdatedAt(selectedRow.updated_at ?? '')
      setOriginalValue(selectedRow.value ?? '')
      setRawValue(selectedRow.value ?? '')
      setFormat(selectedRow.format ?? 'string')
      setStatus(selectedRow.enable ?? false)
      setPassword(selectedRow.password ?? '')
      setOptions(selectedRow.options || '')

      handleStartValue(selectedRow.value, selectedRow.format)
      //handleUpdateValue(selectedRow.value ?? '')
      
    }
  }, [selectedRow])

  useEffect(() => {
    if (editingRowIds.length > 0) {
      setDefaultHiddenColumnNames(["id"]);
    } else {
      setDefaultHiddenColumnNames(["id"]);
    }
  }, [editingRowIds]);

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header/>
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-12">
            <h2><i className="fa fa-cogs"></i> Parâmetros{selectedOption ? ` - ${selectedOption?.name}` : ''}</h2>
          </div>
          <div className="col-lg-12 mt-4">
          <TextField
            select
            label="Automação"
            variant="outlined"
            value={selectedOption?.id || null} 
            onChange={handleSelectionChange}
            fullWidth
          >
            <MenuItem value="">Selecione...</MenuItem>
            <MenuItem value="-1">Global</MenuItem>
            {bots?.map((bot) => {
              return (
                <MenuItem key={bot.id} value={bot.id}>
                  {bot.name}
                </MenuItem>
              );
            })}
          </TextField>
          </div>
          
        </div>
        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row">
            <div className="col-lg-12">
              <div className="ibox ">
                <div className="ibox-content">

                  {/* <select style={{marginBottom: 16}} onChange={handleSelectionChange}>
                    <option value="">Selecione uma Automação</option>
                    <option key="-1" value="-1">Global</option>
                    {bots.map((bot) => (
                      <option key={bot.id} value={bot.id}>
                        {bot.name}
                      </option>
                    ))}
                  </select> */}

                  
                  {selectedOption && userCanView() ? (
                    <Grid rows={rows} columns={columns} getRowId={getRowId}>
                      <PagingState currentPage={pageIndex} pageSize={pageSize} onCurrentPageChange={setPageIndex} />
                      <FilteringState filters={filters} onFiltersChange={handleFilters} />
                      <Table columnExtensions={tableColumnExtensions} rowComponent={TableRowComponent}/>
                      <TableHeaderRow />
                      <TableColumnVisibility defaultHiddenColumnNames={defaultHiddenColumnNames} />
                      <DateTypeProvider for={["expirated_at"]} />
                      <BooleanTypeProvider for={["enable"]} disabled={!userCanEdit(selectedOption?.name)} />
                      <PasswordTypeProvider for={["password"]} />
                      <TypeProvider for={["type"]} />
                      {/*<TableEditRow /> */}
                      {/* {isUserAuthorizedForBot(selectedOption.name) ? (
                        <TableEditColumn 
                          showEditCommand
                          showDeleteCommand 
                          messages={editColumnMessages} 
                        /> 
                      ) : null} */}
                      <CustomPaging totalCount={totalItens} />
                      <PagingPanel />
                      <TableFixedColumns leftColumns={[TableEditColumn.COLUMN_TYPE]} />
                    </Grid>
                  ) : (
                    <div>{!selectedOption || selectedOption === '' ? '' : 'Você não tem acesso a esta automação.'}</div>
                  )}
                  {(!selectedOption)  && (<div><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Selecione uma automação</div>)}

                </div>
                

                <Dialog 
                  open={open} 
                  onClose={handleClose} 
                  maxWidth="md"
                  fullWidth
                  PaperProps={{
                    style: {
                      width: '800px', 
                      margin: '0 auto'
                    },
                  }}
                  >
                  
                <DialogTitle style={{ position: 'relative', color: "#3f51b5", textAlign: 'center' }}>
                  <span style={{ display: 'inline-block', width: '100%'}}>Editar Parâmetro</span>
                  <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleClose}
                      aria-label="close"
                      style={{
                        position: 'absolute',
                        right: 30,
                        top: 20,
                        padding: 0
                      }}
                  >
                      <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <Divider variant="fullWidth" />
                <DialogContent >
                  <DialogContentText style={{ color: "black" }}>
                      {selectedRow && (
                      <>
                        <MIUGrid container justifyContent="space-between">
                          <MIUGrid item xs={12} md={12} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth        
                              label="Nome"
                              value={name}
                              name="name"
                            />
                          </MIUGrid>
                          <MIUGrid item xs={12} md={6} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={true}
                              fullWidth        
                              label="Tipo"
                              value={type === 'parameter' ? 'Parâmetro' : type === 'credential' ? 'Credencial' : type}
                              name="type"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">{type === 'credential' ? <VpnKeyIcon />: <SettingsIcon /> }</InputAdornment>
                                ),
                              }}
                            />
                            
                          </MIUGrid>
                          <MIUGrid item xs={12} md={6} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth   
                              label="Chave"
                              value={key}
                              name="key"
                            />
                          </MIUGrid>
                          <MIUGrid item xs={12} md={12} mt={2}>
                            <TextField
                                multiline
                                rows={6}
                                variant='outlined'
                                disabled={disableFields()}
                                fullWidth   
                                label="Descrição"
                                value={description}
                                name="description"
                                onChange={(e) => {setDescription(e.target.value)}}
                              />
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth  
                              select 
                              label="Status"
                              value={status}
                              //name="format"
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              <MenuItem value={true}>Ativo</MenuItem>
                              <MenuItem value={false}>Inativo</MenuItem>
                            </TextField>
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextField
                                variant='outlined'
                                disabled={true} 
                                fullWidth   
                                label="Criado em"
                                value={formatDateTime(createdAt)}
                                name="created_at"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">{<DateRange/>}</InputAdornment>
                                  ),
                                }}
                              />
                          </MIUGrid>
                          <MIUGrid item xs={4} md={4} mt={2}>
                            <TextField
                                variant='outlined'
                                disabled={true} 
                                fullWidth   
                                label="Ultima atualização"
                                value={formatDateTime(updatedAt)}
                                name="updated_at"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">{<DateRange/>}</InputAdornment>
                                  ),
                                }}
                              />
                          </MIUGrid>
                        </MIUGrid> {/* container */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span style={{ color: '#3f51b5', marginRight: '8px', marginBottom:'8px', marginTop: '8px', fontWeight: 800 }}>Valor</span>
                          <Divider style={{ flex: 1 }} />
                        </div>
                        <MIUGrid container>
                          <MIUGrid item xs={6} md={6} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled={disableFields()}
                              fullWidth  
                              select 
                              label="Formato"
                              defaultValue={'string'}
                              value={format}
                              //name="format"
                              onChange={(e) => handleUpdateFormat(e.target.value)}
                            >
                              <MenuItem value="string">String</MenuItem>
                              <MenuItem value="number">Numérico</MenuItem>
                              <MenuItem value="list">Lista</MenuItem>
                              <MenuItem value="json">Multivalor</MenuItem>
                              
                            </TextField>
                          </MIUGrid>
                          { (format === 'list' || format === 'json') &&
                            <MIUGrid item xs={6} md={6} mt={2}>
                              <TextField
                                variant='outlined'
                                disabled={disableFields()}
                                fullWidth  
                                label={ format === 'list' ? "Separador" : "Campos"}
                                value={options}
                                onChange={(e) => setOptions(e.target.value)}
                                inputProps={{
                                  maxLength: format === 'list' ? 2 : 256, // Limita o número de caracteres para 2
                                }}
                              />  
                            </MIUGrid>
                          }
                           
                          {/* VALOR */}
                          <MIUGrid item xs={12} md={12} mt={2}>
                            {format === 'list' &&
                            <div>
                              <Box display="flex" alignItems="flex-start" flexDirection="row" gap={1}>
                                {/* Exibe a numeração das linhas */}
                                <Box  mt={2}>
                                  {rawValue.split(options).map((_, index) => (
                                    <Typography key={index} variant="body2" color="textSecondary">
                                      {index + 1}
                                    </Typography>
                                  ))}
                                </Box>
                                <TextField
                                  variant='outlined'
                                  multiline
                                  disabled={!userCanEdit(selectedOption?.name)} 
                                  fullWidth  
                                  label="Valor"
                                  value={viewValue}
                                  //name="format"
                                  onChange={(e) => handleUpdateValue(e.target.value)}
                                /> 
                              </Box> 
                            </div>                                
                            }

                            {format === 'string' &&
                              <MIUGrid item xs={12} md={12} mt={2}>
                                <TextField
                                  variant='outlined'
                                  multiline
                                  disabled={!userCanEdit(selectedOption?.name)} 
                                  fullWidth  
                                  label={type === 'credential' ? 'Usuário / E-mail' : 'Valor'}
                                  value={viewValue}
                                  //name="format"
                                  onChange={(e) => handleUpdateValue(e.target.value)}
                                /> 
                              </MIUGrid>    
                            }

                            {format === 'number' && 
                              <MIUGrid item xs={12} md={12} mt={2}>
                                <TextField
                                  variant="outlined"
                                  multiline
                                  disabled={!userCanEdit(selectedOption?.name)} 
                                  fullWidth  
                                  label={'Valor'}
                                  value={viewValue}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Permitir apenas números, vírgulas, pontos e vazio
                                    const numericValue = value.replace(/[^0-9.,]/g, '');
                                    // Atualizar o estado com o valor validado
                                    handleUpdateValue(numericValue);
                                  }}
                                />
                              </MIUGrid>  
                           }

                            {type === 'credential' &&
                              <MIUGrid item xs={12} md={12} mt={2}>
                                <TextField
                                  variant='outlined'
                                  type="password"
                                  disabled={!userCanEdit(selectedOption?.name)} 
                                  fullWidth  
                                  label={'Credencial'}
                                  value={password}
                                  //name="format"
                                  onChange={(e) => handleUpdatePassword(e.target.value)}
                                /> 
                              </MIUGrid>   
                            }

                            {format === 'json' && renderJsonData()}
                            {format === 'json' &&
                              <Button
                                disabled={!userCanEdit(selectedOption?.name)}
                                variant="outlined"
                                onClick={addGroup}
                              >
                                Adicionar Agrupamento
                              </Button>
                            }
                            
                          </MIUGrid>
                          <MIUGrid item xs={12} md={12} mt={2}>
                            <TextField
                              variant='outlined'
                              disabled= {true}
                              fullWidth  
                              label="Raw"
                              value={rawValue}
                              name="raw"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={() => handleCopy(rawValue)} edge="end">
                                      <ContentCopy/>
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />  
                          </MIUGrid>
                        </MIUGrid> {/* container */}
                      </>
                      )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button style={{ marginBottom: 12, marginTop: 12}} onClick={handleClose} color="primary">
                    Fechar
                  </Button>
                  <Button 
                    style={{marginRight: 30, marginBottom: 12, marginTop: 12}}
                    disabled={!userCanEdit(selectedOption?.name)}
                    variant="contained" 
                    onClick={commitChanges} 
                    color="primary">
                    Salvar
                  </Button>
                </DialogActions>
                  <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                  >
                    <Alert onClose={handleCloseSnackbar} severity="success" variant="filled">
                      Texto copiado para a área de transferência!
                    </Alert>
                  </Snackbar>
                </Dialog>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParametroTable;
